export default "/images/ChangeOwnership.png?3bd9fb6ba2b6ec9fba40d63ae52d20f8";